import router from '@input-web/configs/route/route.config';
import { Navigate, Outlet, RouterProvider } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import LoadingIndicator from '@ui/components/molecules/loading-indicator/loading-indicator.molecule';

function NotFoundComponent() {
  return <Navigate replace to="/" />;
}

function PendingComponent() {
  return (
    <div className="items-center justify-center" data-testid="loading">
      <LoadingIndicator open />
    </div>
  );
}

function RootComponent() {
  return (
    <>
      <Outlet />
      <TanStackRouterDevtools />
    </>
  );
}

export default function NavigationApp() {
  return (
    <RouterProvider
      defaultComponent={RootComponent}
      defaultNotFoundComponent={NotFoundComponent}
      defaultPendingComponent={PendingComponent}
      router={router}
    />
  );
}
